export function currencyFormat(value: string | number | undefined): string {
    return (+(value || 0)).toFixed(2);
}
